import React from 'react';

import Main from './Main';
import TelemetryProvider from './components/telemetry/TelemetryProvider';
import { getAppInsights } from './components/telemetry/TelemetryService';
import { AxiosInstance } from './utils/callApi';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || '';
const URL = 'configuration/appinsightskey';

export interface Props {
    history: History;
}
  
interface State {
  appInsights_InstrumentationKey?: string | null; 
}

class App extends React.Component<Props, State> {  
  static displayName = App.name;
  constructor(props) {
    super(props);
    this.state = {};
  }
    componentDidMount() {
       const getAppInsights = async () => {             
            return AxiosInstance({
                  method: 'GET',
                  url: API_ENDPOINT + URL,
                  responseType: 'json',
                  timeout: null,
              })
              .then(resp => {
                  this.setState({
                    appInsights_InstrumentationKey: resp.data});
              })
              .catch(err => {
                  console.log('an error occurred');
                  console.log(err);
              });                          
          };         

        getAppInsights();        
    }    

    render() {
        const {
          props: { history },
          state: { appInsights_InstrumentationKey },         
        } = this;
    
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let appInsights: any;
      
        if (appInsights_InstrumentationKey === undefined) return <Main/>;
    
        try {
          return (
            <TelemetryProvider
              history={history}
              instrumentationKey={appInsights_InstrumentationKey}
              after={() => {
                appInsights = getAppInsights();    
              }}
            >
              <Main/>
            </TelemetryProvider>
          );
        } catch (err) {
          console.log('inerror')
          return (
            <Main/>
          );
        }
      }
}

App.displayName = 'CECLApplication';

export default App;